import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FinalStates, ResultMessage } from '@cashier/cashier-model';

interface PaymentResultPayload {
  message: ResultMessage;
  finalState: FinalStates;
}

export interface PaymentResultState {
  finalState: FinalStates;
  message: ResultMessage | null;
}

export const PAYMENT_RESULT_FEATURE_KEY = 'paymentResult';

export const initialPaymentResultState: PaymentResultState = {
  finalState: FinalStates.PENDING,
  message: null,
};

export const paymentResultSlice = createSlice({
  name: PAYMENT_RESULT_FEATURE_KEY,
  initialState: initialPaymentResultState,
  reducers: {
    setFinalState: (state, action: PayloadAction<FinalStates>) => {
      state.finalState = action.payload;
    },
    setMessage: (state, action: PayloadAction<ResultMessage>) => {
      state.message = action.payload;
    },
    setPaymentResult: (state, action: PayloadAction<PaymentResultPayload>) => {
      state.finalState = action.payload.finalState;
      state.message = action.payload.message;
    },
  },
});

export const paymentResultReducer = paymentResultSlice.reducer;

export const { setFinalState, setMessage, setPaymentResult } =
  paymentResultSlice.actions;
